import type { LstRotinaDoDia, LstStatus } from '../types';
import { formatTimeHHmm } from '../services/lstMatrixHourly';

export function meuPadraoSortKey(r: LstRotinaDoDia): number {
  const t = formatTimeHHmm(r.template.scheduled_time);
  if (t) {
    const [h, m] = t.split(':').map(Number);
    return h * 60 + m;
  }
  return { inicio: 0, meio: 720, fim: 1080 }[r.template.period] + r.template.sort_order;
}

export function meuPadraoNowMinutes(): number {
  const n = new Date();
  return n.getHours() * 60 + n.getMinutes();
}

export function meuPadraoMinutesUntil(time: string | null): number | null {
  const t = formatTimeHHmm(time);
  if (!t) return null;
  const [h, m] = t.split(':').map(Number);
  return h * 60 + m - meuPadraoNowMinutes();
}

export function meuPadraoIsPending(status: LstStatus | 'pendente'): boolean {
  return status === 'pendente' || status === 'nao_realizado';
}

export function meuPadraoIsLate(rotina: LstRotinaDoDia, status: LstStatus | 'pendente'): boolean {
  if (status === 'realizado' || status === 'realizado_com_desvio' || status === 'processo_parado') {
    return false;
  }
  const t = rotina.template.scheduled_time;
  if (!t) return status === 'nao_realizado';
  const diff = meuPadraoMinutesUntil(t);
  return diff != null && diff < 0;
}

export function meuPadraoRowId(templateId: string): string {
  return `meu-padrao-rotina-${templateId}`;
}
